import { AsyncActionStatuses } from '../helpers/types.js';
/**
 * Builder case class for managing different cases of the asynchronous task
 * @param _cases List of cases defined for a specific asynchronous task
 */
var BuilderCase = /** @class */ (function () {
    function BuilderCase() {
        this._cases = [];
        this._asyncAction = undefined;
    }
    Object.defineProperty(BuilderCase.prototype, "cases", {
        // Getters
        /**
         * Get the list of cases
         */
        get: function () {
            return this._cases;
        },
        /**
         * Update the cases
         */
        set: function (cases) {
            this._cases = cases;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BuilderCase.prototype, "asyncAction", {
        /**
         * Get the async action
         */
        get: function () {
            return this._asyncAction;
        },
        // Setters
        /**
         * Update the async action
         * @param asyncAction Async Action value
         */
        set: function (asyncAction) {
            this._asyncAction = asyncAction;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Method that add a new case into the _cases list and return a new case builder object
     * @param status Status of the asynchronous task
     * @param handler Function that is executed depending on the specific status
     * @returns
     */
    BuilderCase.prototype.case = function (status, handler) {
        this._cases.push({
            status: status,
            handler: handler
        });
        return this;
    };
    /**
     * Method that add a pending case into the _cases list and return a new case builder object
     * @param handler Function that is executed depending on the specific status
     * @returns
     */
    BuilderCase.prototype.onPending = function (handler) {
        return this.case(AsyncActionStatuses.PENDING, handler);
    };
    /**
     * Method that add a fulfilled case into the _cases list and return a new case builder object
     * @param handler Function that is executed depending on the specific status
     * @returns
     */
    BuilderCase.prototype.onFulfilled = function (handler) {
        return this.case(AsyncActionStatuses.FULFILLED, handler);
    };
    /**
     * Method that add a rejected case into the _cases list and return a new case builder object
     * @param handler Function that is executed depending on the specific status
     * @returns
     **/
    BuilderCase.prototype.onRejected = function (handler) {
        return this.case(AsyncActionStatuses.REJECTED, handler);
    };
    return BuilderCase;
}());
export { BuilderCase };
